module.exports = __webpack_public_path__ + "static/367117_1_0-ceec9130659b95d6cd4bc7f9fda9301c.woff2";